<template>
    <div>
      <CButton 
        v-for="(button, index) in buttons"
        :key="index"
        :theme="button.theme"
        :icon="button.icon"
        :label="button.label"
        :class="button.class"
        :disabled="button.isDisabled"
        @click.prevent="handleButtonClick(button.eventName)"
      />
    </div>
  </template>

<script>
import CButton from '@/components/contracts/edit/atoms/CButton';

export default {
  name: 'ContractManagementBar',
  components: {
    CButton
  },
  props: {
    isDraft: Boolean,
    isAdmin: Number,
    submitting: Boolean,
    savingAsDraft: Boolean,
    submittingContractToAccept: Boolean,
    schedule: Object
  },
  methods: {
    handleButtonClick(eventName) {
        this.$emit(eventName);
    }
  },
  computed: {
    buttons() {
      return [
        {
          condition: this.$route.params.from,
          theme: 'secondary',
          icon: 'keyboard_backspace',
          label: 'Wróć do listy',
          isLoading: false,
          isDisabled: false,
          class: {},
          eventName: 'route-back'
        },
        {
          condition: !this.$route.params.from,
          theme: 'primary',
          icon: 'close',
          label: 'Zamknij',
          isLoading: false,
          isDisabled: false,
          eventName: 'route-to-edit-client'
        },
        {
          condition: this.isDraft,
          theme: 'success',
          icon: 'save',
          label: 'Zapisz szkic',
          isLoading: this.submitting && this.savingAsDraft,
          isDisabled: this.submitting,
          class: { isLoading: this.submitting && this.savingAsDraft },
          eventName: 'save-draft'
        },
        {
          condition: this.isDraft && this.isAdmin,
          theme: 'secondary',
          icon: 'save',
          label: 'Przekształć w umowę',
          isLoading: this.submitting && this.savingAsDraft,
          isDisabled: this.submitting,
          class: { isLoading: this.submitting && this.savingAsDraft },
          eventName: 'save-contract'
        },
        {
          condition: !this.isDraft,
          theme: 'success',
          icon: 'save',
          label: 'Zapisz umowę',
          isLoading: this.submitting && this.savingAsDraft,
          isDisabled: this.submitting,
          class: { isLoading: this.submitting },
          eventName: 'save-contract'
        },
        {
          condition: this.isDraft && this.schedule.is_accepted === 0 && !this.isAdmin,
          theme: 'warning',
          icon: 'done',
          label: 'Przekaż umowę do akceptacji',
          isLoading: this.submittingContractToAccept,
          isDisabled: this.submitting || this.submittingContractToAccept,
          class: { isLoading: this.submittingContractToAccept },
          eventName: 'send-contract-to-accept'
        }
      ].filter(button => button.condition);
    }
  }
}
</script>

<style scoped>
</style>
